import { observer } from "mobx-react";
import * as React from "react";
import { applicationStore } from "../../../stores/ApplicationStore";
import { THEME } from "../../../theme/ThemeStore";
import { ApplicationValues } from "../../../types/models";
import { pushRoute } from "../../app/router/history";
import { ContentWrapper } from "../../ui/ContentWrapper";
import { TopImage } from "../../ui/TopImage";
import { DetailsForm } from "../DetailsForm";
import { ApplicationRoutes } from "../router/ApplicationRoutes";

export const DetailsSite = observer(() => {
    const handleSubmit = (application: ApplicationValues) => {
        applicationStore.currentApplication = application;
        applicationStore.isStepFinished["details"] = true;
        pushRoute(ApplicationRoutes.DATA_UPLOAD);
    };

    const handleBack = () => {
        if (!applicationStore.canNavigate) {
            const currentStepIndex = Object.keys(applicationStore.isStepFinished).indexOf("details");
            applicationStore.setCurrentAndNextStepsToUnfinished(currentStepIndex);
        }
        pushRoute(ApplicationRoutes.PERSONAL_DATA);
    };

    React.useEffect(() => {
        if (!applicationStore.isStepFinished["personalData"]) {
            pushRoute(ApplicationRoutes.PERSONAL_DATA);
        }
    }, []);

    return (
        <>
            <TopImage imageUrl={THEME.Images.headerImage02} />
            <ContentWrapper>
                <DetailsForm onSubmit={handleSubmit} onBack={handleBack} />
            </ContentWrapper>
        </>
    );
});
